import { createApplicationService } from "./base/applicationServiceBase";
import { API } from "api/axios.config";

const COUNTRIES_BASE = "/utilities/countries";

const fetchCountriesAPI = () => API.get(`${COUNTRIES_BASE}?active=true`);

const baseService = createApplicationService({
  name: "countries",
  apiFetchFn: fetchCountriesAPI,
});

const countryReducer = baseService.reducer;
const getCountries = baseService.getData;
const useCountries = baseService.useData;

export { countryReducer, getCountries, useCountries };
